<template>
	<div class="cooperation-tab">
		<data-card title="合作数据" ref="cooperationRef" :list="cooperationList" @submit="getPartnerData"></data-card>
		<data-card class="mt-24" title="成交数据" ref="makeRef" :list="makeFilterList" @submit="getFinishData"></data-card>
		<data-card class="mt-24 await" title="待办数据" :list="awaitList">
			<template v-slot:right>
				<div class="look" @click="goToUrl('/cooperationProgress/list')">
					<span>查看合作进度</span>
					<i class="el-icon-arrow-right"></i>
				</div>
			</template>
		</data-card>
	</div>
</template>

<script>
import dataCard from '../dataCard';
import { getPartnerData, getFinishData, getWaitData } from '@/api/secondColonelManage';
import { drRoleType } from '@/utils/dataMap';
export default {
	name: 'cooperationTab',
	components: {
		dataCard,
	},
	props: {
		id: {
			type: [String, Number],
			default: 0,
		},
	},
	data() {
		return {
			cooperationList: [
				{ label: '申样商品数', desc: '该团长【全部状态】的样品订单中商品的数量', number: 0, key: 'applyProductNum' },
				{
					label: '寄样商品数',
					desc: '该团长关联样品订单物流状态为【已发货、运输中、已到货】的样品订单中商品的数量',
					number: 0,
					key: 'sendProductNum',
				},
				{
					label: '出单商品数',
					desc: '推广者为该团长ID的商品数量',
					number: 0,
					key: 'productPayCount',
				},
				{ label: '申样达人数', desc: '该团长关联的申请样品的达人数量', number: 0, key: 'applyAnchorNum' },
				{
					label: '寄样达人数',
					desc: '该团长关联样品订单物流状态为【已发货、运输中、已到货】的样品订单中的达人数量',
					number: 0,
					key: 'sendAnchorNum',
				},
				{
					label: '出单达人数',
					desc: '推广者为该团长ID的达人数量',
					number: 0,
					key: 'anchorPayCount',
				},
				{ label: '申样次数', desc: '各做进度中，该团长关联的申请样品的次数', number: 0, key: 'applyNum' },
				{ label: '寄样次数', desc: '合作进度中，该团长关联的样品发货次数', number: 0, key: 'sendNum' },
				{ label: '寄样率', desc: '寄样次数/申样次数', number: 0, isRate: true, key: 'sendRate' },
				{ label: '寄样出单率', desc: '出单样品订单/寄样次数', number: 0, isRate: true, key: 'sendOrderRate' },
			],
			makeList: [
				{
					label: '预估订单数',
					desc: '该团长【全部状态】的订单数量',
					number: 0,
					dz: true,
					zs: true,
					isShow: true,
					key: 'payOrderCount',
				},
				{
					label: '预估GMV',
					desc: '该团长【全部状态】订单的支付金额之和',
					number: 0,
					dz: true,
					zs: true,
					isShow: true,
					isDecimals: true,
					key: 'payGmv',
				},
				{
					label: '预估到手服务费',
					desc: '预估服务费收入-预估服务费支出-技术服务费，预估可提取的金额;',
					number: 0,
					isDecimals: true,
					isShow: this.$auth.hasPermi('system:goods-ServiceRate'),
					key: 'estimatedServiceFee',
				},
				{
					label: '已结算订单数',
					desc: '该团长【已结算状态】的订单数量',
					number: 0,
					isShow: this.$auth.hasPermi('system:goods-ServiceRate'),
					key: 'settleOrderCount',
				},
				{
					label: '已结算GMV',
					desc: '该团长【已结算状态】订单的服务费收入-服务费支出',
					number: 0,
					isDecimals: true,
					isShow: this.$auth.hasPermi('system:goods-ServiceRate'),
					key: 'settleGmv',
				},
				{
					label: '已结算到手服务费',
					desc: '该团长【已结算状态】订单的服务费收入-服务费支出',
					number: 0,
					isDecimals: true,
					isShow: this.$auth.hasPermi('system:goods-ServiceRate'),
					key: 'settleServiceFee',
				},
			],
			awaitList: [
				{ label: '待寄样数', desc: '已申样，未发货的商品数', number: 0, key: 'wait_send_num' },
				{ label: '待收货数', desc: '已寄样，未收货的商品数', number: 0, key: 'wait_receive_num' },
				{ label: '待排期数', desc: '已收货，待确认排期的商品数', number: 0, key: 'wait_plan_num' },
				{ label: '待开播数', desc: '已排期，待确认开播的商品数', number: 0, key: 'wait_live_num' },
			],
			followList: [],
			date_type: 30,
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			total: 0,
			userId: '',
		};
	},
	computed: {
		makeFilterList() {
			let { makeList } = this;
			makeList = [...makeList];
			makeList = makeList.filter(item => item.isShow);
			return makeList;
		},
	},
	methods: {
		goToUrl(path) {
			if (!this.$auth.hasPermi('system:cooperationProgress-query')) {
				this.$message.warning('暂无合作进度页面权限');
				return;
			}
			const { href } = this.$router.resolve({ path });
			window.open(href, '_blank');
		},
		getInfo(e) {
			this.userId = e;
			// this.getFollowList()
			this.$refs.cooperationRef.reset(30);
			this.$refs.makeRef.reset(30);
			this.getPartnerData();
			this.getFinishData();
			this.getWaitData();
		},
		async getPartnerData(params) {
			const { userId, id } = this;
			if (!params) {
				const { date_type } = this;
				params = { date_type };
			}
			params = { ...params, team_institution_id: id, userId };
			const { partner_data = {} } = await getPartnerData(params);
			this.cooperationList = this.cooperationList.map(item => {
				return {
					...item,
					number: partner_data[item.key],
				};
			});
		},
		async getFinishData(params) {
			const { userId, id } = this;
			if (!params) {
				const { date_type } = this;
				params = { date_type };
			}
			params = { ...params, team_institution_id: id, userId };
			const { finish_data = {} } = await getFinishData(params);
			this.makeList = this.makeList.map(item => {
				return {
					...item,
					number: finish_data[item.key],
				};
			});
		},
		async getWaitData() {
			const { userId, id } = this;
			const { wait_data = {} } = await getWaitData({ team_institution_id: id, userId });
			this.awaitList = this.awaitList.map(item => {
				return {
					...item,
					number: wait_data[item.key],
				};
			});
		},
	},
};
</script>

<style lang="less" scoped>
.cooperation-tab {
	margin-top: 10px;
	margin-bottom: 24px;
	.await ::v-deep .item {
		width: 25%;
	}
	.look {
		font-size: 14px;
		color: #999;
		cursor: pointer;
		display: flex;
		align-items: baseline;
	}
	.table-btn {
		cursor: pointer;
		color: @color-primary;
	}
}
</style>
